import React from 'react';
import { cn } from '@/src/infrastructure/lib/utils';
import { Particles } from '../Particles';

export interface LivingProps {
  children: React.ReactNode;
  motionType?: 'fire' | 'flowers' | 'water' | 'fireflies' | 'petals';
  className?: string;
}

export function Living({ children, motionType = 'fireflies', className }: LivingProps) {
  const particleEffectMap = {
    fire: 'embers' as const,
    flowers: 'petals' as const,
    water: 'bubbles' as const,
    fireflies: 'fireflies' as const,
    petals: 'rose_petals' as const,
  };

  const effectName = particleEffectMap[motionType] ?? 'fireflies';

  return (
    <div className={cn('relative w-full h-full overflow-hidden isolate z-0', className)}>
      {/* Ambient Natural Motion Particle System */}
      <Particles effect={effectName} />

      {/* Subtle pulsing warmth radial glow */}
      <div
        className="absolute inset-0 pointer-events-none z-10 animate-pulse opacity-30"
        style={{
          background:
            motionType === 'fire'
              ? 'radial-gradient(circle at center, rgba(255,100,0,0.35) 0%, transparent 70%)'
              : motionType === 'flowers' || motionType === 'petals'
              ? 'radial-gradient(circle at center, rgba(255,182,193,0.3) 0%, transparent 70%)'
              : 'radial-gradient(circle at center, rgba(255,215,0,0.25) 0%, transparent 70%)',
        }}
        aria-hidden
      />

      <div className="relative z-20 w-full h-full flex items-center justify-center">
        {children}
      </div>
    </div>
  );
}
